{
    "PromptDeletereport": "Are you sure you want to delete?",
    "PromptDeletereports": "Are you sure you want to permanently delete the selected reports?",
    "PromptEmptyrecyclebin": "Are you sure you want to permanently delete all reports in recycle bin?",
    "PromptRemovereport": "Are you sure you want to remove this report?",
    "PromptReportswillbedeletedpermanently": "Reports will be permanently deleted and cannot be restored.",
    "AreYouSureDelete": "Are you sure you want to delete?",
    "AreYouSureRemove": "Are you sure you want to remove this report?",
    "NAME": "LanguagePrompt",
    "LanguagePrompt_PromptConfirm": "Confirm",
    "LanguagePrompt_PromptCancel": "Cancel"
}